module.exports = __webpack_public_path__ + "media/images/lb/111-0c0d806e097120caae1085eb7e295d3d.svg";